'use es6';

import { productVersionSelector } from '../../selectors/ProductsSelectors';
/**
 * Returns a comma separated string of quantity pack quantities in a list of product configurations,
 * filtered to just one product version by skuId
 */

export const seleniumUnitQuantitiesStringSelector = (state, {
  productConfigurations,
  productVersionSkuId
}) => {
  const quantityPackDetails = productVersionSkuId ? productVersionSelector(state, {
    skuId: productVersionSkuId
  }).quantityPackDetails : [];
  return productConfigurations.filter(({
    skuId
  }) => quantityPackDetails.some(({
    skuId: searchSkuId
  }) => searchSkuId === skuId)).map(({
    quantity
  }) => quantity).join(',');
};
/**
 * Returns a comma separated string of quantity pack unit types in a list of product configurations,
 * filtered to just one product version by skuId
 */

export const seleniumUnitsTypesStringSelector = (state, {
  productConfigurations,
  productVersionSkuId
}) => {
  const quantityPackDetails = productVersionSkuId ? productVersionSelector(state, {
    skuId: productVersionSkuId
  }).quantityPackDetails : [];
  return productConfigurations.filter(({
    skuId
  }) => quantityPackDetails.some(({
    skuId: searchSkuId
  }) => searchSkuId === skuId)).map(({
    skuId
  }) => {
    const details = quantityPackDetails.find(({
      skuId: searchSkuId
    }) => searchSkuId === skuId);
    return details.quantityUnit.unitType;
  }).join(',');
};